try{self['workbox:sw:6.5.0']&&_()}catch(e){}// eslint-disable-line